/*********************************************************************************
 1. Colours
 *********************************************************************************/

export const Colours = {
    White: '#FFFFFF',
    Carnation: '#FC4F62',
    Lima: '#7ED321',
    Tundora: '#4A4A4A',
    SilverChalice: '#ABABAB',
    Alto: '#DCDCDC',
    Gallery: '#EDEDED',
    Alabaster: '#F9F9F9',
    DodgerBlue: '#3FB3FD'
};


/*********************************************************************************
 2. Spacing
 *********************************************************************************/

export const Spacing = {
    Tiny: '10px',
    Small: '20px',
    Medium: '30px',
    Large: '40px',
    Massive: '80px'
};


/*********************************************************************************
 3. Breakpoints
 *********************************************************************************/

export const Breakpoints = {
    Tablet: 768
};


/*********************************************************************************
 4. Borders
 *********************************************************************************/

export const Borders = {
    Radius: '4px'
};



// WEBPACK FOOTER //
// ./src/styles/variables.js